<template>
  <button @click.stop.prevent="favoriteToggle($event)">
    <span :class="flagClass"></span>
  </button>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, ref } from 'vue'

import { DocListItem } from '@/models/interfaces'
import { DocFavoriteView } from '@/models/doc.favorite'
import { assertNotNull } from '@/helpers/typing'

const props = defineProps<{
  doc: DocListItem
}>()

const view = ref<DocFavoriteView | null>(null)

onBeforeMount(() => {
  view.value = new DocFavoriteView(props.doc)
})

const flagClass = computed(() => {
  return props.doc.is_favorite
    ? 'collection__icon collection__icon--active iconfont iflag2'
    : 'collection__icon iconfont iflag'
})

/**
 * Click handler.
 *
 * We did use the CSS property `:disabled` to prevent the favorite toggle
 * being clicked too often, but if the user clicks favorite button twice,
 * the book is being opened, which is not the behavior we want. This was
 * happening because the disabled button still propagates event to the
 * parent, which is book card.
 *
 * Instead of disabling the button via CSS, we just stop the
 * event propagation and do nothing in the click handler.
 */
async function favoriteToggle($event: Event): Promise<void> {
  if (view.value?.buttonDisabled) {
    return
  }
  await assertNotNull(view.value).favoriteToggle($event)
}
</script>
